// Как показать пользователю отказ суммаризации или чата.
//
// Бэкенд различает два случая: шлюз LLM перегружен (повторы внутри сервиса уже
// исчерпаны, но через пару минут попытка осмысленна) и всё остальное. Первый
// приходит кодом `llm_unavailable` в статусе задачи и ответом 503 в чате.
// Пользователю важна именно эта разница: ждать или менять входные данные.

const OVERLOAD_TASK = 'Модель перегружена. Попробуйте повторить через пару минут.';
const OVERLOAD_CHAT = 'Модель перегружена, попробуйте ещё раз через пару минут.';
const GENERIC_TASK = 'Ошибка при обработке задачи';
const GENERIC_CHAT = 'Ошибка при получении ответа.';
// Ответ не пришёл за минуту (таймаут в chatService). Отдельный текст: «ошибка»
// тут неправда — запрос ушёл, ответа нет, и повтор обычно помогает.
const TIMEOUT_CHAT = 'Ассистент задумался крепче обычного. Дальше ждать смысла нет — повторите вопрос.';
const OVERAGE_CHAT = 'Пакет протоколов по тарифу исчерпан. Сменить тариф — в личном кабинете, кнопка «Сменить тариф».';
const OVERAGE_TASK = 'Пакет протоколов по вашему тарифу исчерпан. Сменить тариф — в личном кабинете, кнопка «Сменить тариф».';
// Лимит ИИ-сервиса — не тариф пользователя и не перегрузка: повтор не поможет,
// вопрос решает администратор. Пока такой отказ выглядел как «Ошибка при
// обработке задачи», два часа простоя 22.08 никто не мог объяснить.
const BUDGET = 'Лимит ИИ-сервиса на период исчерпан. Повтор не поможет — сообщите администратору.';
const AUTH = 'ИИ-сервис не принял доступ. Сообщите администратору.';

/**
 * Текст и доступность повтора по коду ошибки упавшей задачи.
 * Кнопку «Повторить» даём только при перегрузке: в остальных случаях повтор
 * с теми же данными приведёт к тому же отказу.
 */
export function describeTaskError(errorCode, detail) {
  if (errorCode === 'llm_unavailable') {
    return { message: OVERLOAD_TASK, canRetry: true };
  }
  // Текст шлюза показываем как есть: он уже на русском, с суммами и ссылкой на
  // кабинет — наш обобщённый вариант беднее и врёт про детали.
  if (errorCode === 'llm_budget_exceeded') {
    return { message: detail || BUDGET, canRetry: false };
  }
  if (errorCode === 'llm_auth') {
    return { message: detail || AUTH, canRetry: false };
  }
  return { message: GENERIC_TASK, canRetry: false };
}

/**
 * Текст отказа при ЗАПУСКЕ задачи протокола (POST /tasks не принял запрос).
 *
 * 🔴 Раньше здесь любой отказ показывался как «Ошибка при запуске обработки»:
 * бэкенд отдаёт 429 с готовым русским текстом про исчерпанный пакет тарифа
 * (shared/quota.py), а фронт его выбрасывал. Человек видел слово «ошибка» и не
 * мог понять ни что случилось, ни что делать. Поймано 28.08.2026 на клиентском
 * контуре: пакет кончился 27.08 в 21:15, и следующие сутки отказ выглядел
 * поломкой продукта. Чат при этом объяснял то же самое внятно — describeChatError
 * ниже разбирал статусы, а путь протокола нет.
 */
export function describeStartError(status, detail) {
  if (status === 429) return detail || OVERAGE_TASK;
  if (status === 402) return detail || BUDGET;
  if (status === 403) return detail || AUTH;
  if (status === 503) return OVERLOAD_TASK;
  return GENERIC_TASK;
}

/** Текст ответа в чате по HTTP-статусу неудачного запроса.
 *
 * `code` — код ошибки axios: у истёкшего таймаута ответа нет вовсе, и статус
 * приходит пустым, поэтому его разбираем отдельно.
 */
export function describeChatError(status, detail, code) {
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') return TIMEOUT_CHAT;
  // 429 от квоты — это не перегрузка: ждать бесполезно, кончился пакет тарифа.
  if (status === 429) return OVERAGE_CHAT;
  if (status === 402) return detail || BUDGET;
  if (status === 403) return detail || AUTH;
  return status === 503 ? OVERLOAD_CHAT : GENERIC_CHAT;
}
